define("settings/templates/groups/group/integrations", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Integrations::Mavely @group={{this.model.group}} />
  */
  {
    "id": "j2k8CZZg",
    "block": "[[[8,[39,0],null,[[\"@group\"],[[30,0,[\"model\",\"group\"]]]],null]],[],false,[\"integrations/mavely\"]]",
    "moduleName": "settings/templates/groups/group/integrations.hbs",
    "isStrictMode": false
  });
});